module.exports = __webpack_public_path__ + "img/seed_logo1.8a0dd033.png";